import { TabPanel, TabView, useTranslation } from '@components';

import AdminNotificationTemplates from '@containers/admin/AdminNotificationTemplatesContainer';
import AdminWorkMessages from '@containers/admin/AdminWorkMessagesContainer';
import type { IWork } from '@models';
import * as React from 'react';
import { WorkToolbar } from './WorkToolbar';

export interface IProps {
    work: IWork;
}

export function AdminWorkNotifications(props: IProps) {
    const { t } = useTranslation();

    return (<div className='c md pd'>
        <WorkToolbar work={props.work} />

        <TabView>
            <TabPanel header={t('Messages')}>
                <AdminWorkMessages work={props.work} />
            </TabPanel>
            <TabPanel header={t('Templates')}>
                <AdminNotificationTemplates work={props.work} />
            </TabPanel>
        </TabView>
    </div>)
}
